import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import lang from "../resources/lang";
import { t } from 'i18next';
export default class LangPicker extends React.Component {
    constructor(props) {
        super(props);

        this.dropdown = React.createRef();
        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false
        };
        this.changeLanguage(props.oletuskieli);
    }

    toggle(e) {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    changeLanguage(selectedLanguage) {
        window.dataLayer.push({
            event: 'bot_language_change', // Event -nimi kaikille tapahtumille kun k�ytt�j� vaihtaa kielivalintaa
            language: selectedLanguage // Valittu kielivalinta. Eli joko 'Fi', 'Sv' tai 'En'
        });
        lang.changeLanguage(selectedLanguage);
    }

    render() {
        return (
            <div ref={this.dropdown} className="lang-picker">
                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                    <DropdownToggle id="langpicker-toggle" tag="button" type="button" className="form-control" caret>
                        {lang.language}
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={() => this.changeLanguage("Fi")}><img src="images/fi.png"></img> {t("kieliKoodiFi")}</DropdownItem>
                        <DropdownItem onClick={() => this.changeLanguage("Sv")}><img src="images/se.png"></img> {t("kieliKoodiSv")}</DropdownItem>
                        <DropdownItem onClick={() => this.changeLanguage("En")}><img src="images/gb.png"></img> {t("kieliKoodiEn")}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        );
    }
}